import request from 'superagent';
import { getUserToken } from 'services/authentication';
import config from 'app/config';

const url = `${config.get('CREATE_JOBS_API_HOST')}/v1/jobs`;

export default data => {
  return new Promise((resolve, reject) => {
    request
      .post(url)
      .send(data)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(err || new Error(`Request completed with code ${res.code}`));
        } else {
          resolve(res.body);
        }
      });
  });
};
